/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { cx } from "@panda/css";
import { HStack } from "@panda/jsx";

import { LottieLoading } from "./LottieLoading";

interface Props {
	className?: string;
	fill?: boolean;
}

export const Loading = ({ className = "", fill = true }: Props): React.JSX.Element => {
	return (
		<div className={cx(`loading`, className)}>
			<HStack
				justifyContent={"center"}
				alignItems={"center"}
				h={fill ? "94vh" : "auto"}
				paddingBottom={fill ? "eds.dimension.72" : ""}
				maxWidth="500px"
				margin="0 auto"
			>
				<LottieLoading />
			</HStack>
		</div>
	);
};
